import React from "react";
import "./JobTypesNav.css";

function JobTypesNav({ activeSubTab, setActiveSubTab, subTabs }) {
  return (
    <nav className="job-types-nav" aria-label="Виды работ">
      <div className="job-types-nav__tabs">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={
              tab.id === activeSubTab
                ? "job-types-nav__button job-types-nav__button--active"
                : "job-types-nav__button"
            }
            onClick={() => setActiveSubTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </nav>
  );
}

export default JobTypesNav;
